import React from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiChevronRight, mdiZodiacTaurus } from '@mdi/js';
import * as R from 'ramda';

import Container from '@components/Container';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Shanghai');

const useStyles = createUseStyles(({
  rem,
}) => ({
  tracItem: {
    boxSizing: 'border-box',
    height: 120,
    width: '100%',
    borderRadius: 5,
    marginBottom: 15,
    color: '#000000',
    letterSpacing: 1,
    padding: [rem(10), rem(4)],
    border: '1px solid rgba(13, 38, 91, 0.08)',
    boxShadow: '0px 1px 1px -1px rgba(13, 38, 91, 0.08), 0px 3px 3px 0px rgba(13, 38, 91, 0.06), 0px 5px 6px 2px rgba(13, 38, 91, 0.04)',
  },
  itemImage: {
    height: rem(60),
  },
  itemCenter: {
    boxSizing: 'border-box',
    maxWidth: rem(200),
    // paddingRight: rem(10),
    '& > span': {
      fontSize: rem(12),
      lineHeight: '18px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      wordBreak: 'break-all',
    },
    '& > span:nth-child(2)': {
      color: 'rgba(0, 0, 0, 0.4)',
    },
  },
  tracTitle: {
    fontSize: '14px !important',
    fontWeight: 'bold',
    color: '#000000',
    lineHeight: '30px !important',
    maxWidth: rem(160),
  },
  cert: {
    display: 'flex',
    alignItems: 'center',
    color: '#57BCF9 !important',
    fontSize: rem(12),
    fontWeight: 'bold',
    lineHeight: '20px !important',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    wordBreak: 'break-all',
    margin: '0px !important',
  },
  more: {
    width: '100%',
    textAlign: 'center',
    margin: '10px auto',
    color: '#57BCF9',
    cursor: 'pointer',
  },
  right: {
    padding: rem(10),
  },
}), {
  name: 'TrancSourceBase'
})

// 溯源信息
const TrancSourceBase = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    t,
    type,
    icon,
    data,
    belong,
    idx,
    handleOpenModal,
    handleOpenTrancCertModal,
  } = props;

  const time = R.pathOr(new Date().getTime(), ['base', 'timestamp'])(data);

  const country = R.pathOr('', ['custom', 'gps', 'country'])(data);
  const city = R.pathOr('', ['custom', 'gps', 'city'])(data);

  const createCertLine = () => {
    if (belong === 'trackinfo') return null;
    const certList = R.pathOr([], ['custom', 'certlist'])(data);
    if (certList && certList.length === 0) return null;
    if (certList && certList.length > 0) {
      return (
        <p
          className={classes.cert}
          onClick={() => handleOpenTrancCertModal(belong, idx)}
        >
          <Icon
            path={mdiZodiacTaurus}
            size={0.3}
            style={{ marginRight: 5, transform: 'rotate(180deg)' }}
          />
          <span>
           {t('certificate')}
          </span>
        </p>
      )
    }
  }

  return (
    <Container
      flex
      alignItems='center'
      justify='space-around'
      className={classNames(classes.tracItem)}
    >
      <img
        alt='trac'
        src={icon}
        className={classes.itemImage}
      />
      <Container
        flex
        direction='column'
        className={classes.itemCenter}
      >
        <span className={classes.tracTitle}>{type}</span>
        <span>{dayjs.tz(time).format('YYYY-MM-DD HH:mm:ss')}</span>
        <span>{`${country} ${city}`}</span>
        {createCertLine()}
      </Container>

      <Icon
        path={mdiChevronRight}
        size={0.5}
        className={classes.right}
        onClick={() => handleOpenModal(belong, idx)}
      />
    </Container>
  )
};

TrancSourceBase.propTypes = {
  t: PropTypes.func.isRequired,
  belong: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  handleOpenTrancCertModal: PropTypes.func,
}

export default TrancSourceBase;
